import { ComponentType } from "react";
import classNames from "../../utils/classNames";

interface ToolTileProps {
  title: string;
  subtitle: string;
  hoverClassName: string;
  icon: ComponentType<{ className?: string }>;
  onClick: () => void;
}

export default function ToolTile({
  title,
  subtitle,
  hoverClassName,
  icon: Icon,
  onClick,
}: ToolTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "group w-full rounded-2xl bg-white border border-gray-200 shadow-sm p-6 text-left transition-all duration-200 hover:shadow-md hover:-translate-y-0.5",
        hoverClassName
      )}
    >
      <div className="w-12 h-12 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center">
        <Icon className="w-6 h-6" />
      </div>
      <h3 className="mt-4 text-base font-semibold text-gray-900">{title}</h3>
      <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
    </button>
  );
}
